import { render, staticRenderFns } from "./mark-column.vue?vue&type=template&id=bd9a8990&scoped=true"
import script from "./mark-column.vue?vue&type=script&lang=js"
export * from "./mark-column.vue?vue&type=script&lang=js"
import style0 from "./mark-column.vue?vue&type=style&index=0&id=bd9a8990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9a8990",
  null
  
)

export default component.exports